import { useSelector, useDispatch } from 'react-redux'

import { promptToRemoveScheduledDowngrade } from 'features/billing/actions/prompt_to_remove_scheduled_downgrade'
import {
  isDowngradeScheduledSelector,
  unableToChangeTierSelector,
  isSubscriptionExpiringSelector
} from 'features/billing/selectors'

export const usePromptToRemoveScheduledDowngrade = () => {
  const isDowngradeScheduled = useSelector(isDowngradeScheduledSelector)
  const unableToChangeTier = useSelector(unableToChangeTierSelector)
  const isSubscriptionExpiring = useSelector(isSubscriptionExpiringSelector)

  const dispatch = useDispatch()

  return promptToRemoveScheduledDowngrade(dispatch, { isDowngradeScheduled, unableToChangeTier, isSubscriptionExpiring })
}
